import React, { useMemo } from 'react'
import { ToolComponentCtx } from '@hose/chat-app'
import { Tooltip } from '@hose/eui'
import Markdown from './Markdown'
import './index.less'

type AgentApproval = {
  id: string
  agentName: string
  agentIcon?: string
  nodeName?: string
  aiResult?: string
  content?: string
}

type AuditFlowResult = {
  flowId?: string
  flowCode?: string
  agentApprovals?: AgentApproval[]
}

const getOpinionColor = (result?: string) => {
  switch (result) {
    case '同意':
      return 'var(--eui-function-success-500, #00B42A)'
    case '驳回':
      return 'var(--eui-function-danger-500, #F53F3F)'
    case '备注同意':
      return 'var(--eui-function-warning-500, #FF7D00)'
    case '建议复核':
      return 'var(--eui-text-title, rgba(29, 33, 41, 0.90))'
    default:
      return 'var(--eui-text-title, rgba(29, 33, 41, 0.90))'
  }
}

const AuditFlow: React.FC<ToolComponentCtx> = (props) => {
  const { state } = props

  const data: AuditFlowResult = useMemo(() => {
    if(props.state === 'result'){
      if(typeof props?.result === 'string'){
        try{
          return JSON.parse(props?.result)
        } catch{
          return props?.result
        }
      } else{
        return props?.result || []
      }
    }
    return []
  }, [props])

  if (state !== 'result') {
    return null
    // return <ToolLoading speed='slow' />
  }

  if(typeof data === 'string'){
    return <span>{data}</span>
  }
  
  const approvals = Array.isArray(data?.agentApprovals) ? data?.agentApprovals : []

  return (
    <div className="audit-flow-container">
      <div className="audit-flow-title">单据的预审意见如下：</div>
      <div className="audit-flow-card">
        <div className="audit-flow-header">
          <span className="audit-flow-header-label">单据编号</span>
          <span className="audit-flow-header-value">{data?.flowCode || '-'}</span>
        </div>

        {approvals.map((item) => (
          <div className="approval-block" key={item.id}>
            <div className="approval-block-meta">
              <div className="meta-left">
                <div className="meta-left-title">AI智能体名称</div>
                <div className="meta-left-content">
                  {!!item?.agentIcon && (
                    <img className="avatar" src={item.agentIcon} alt="avatar"/>
                  )}
                  <Tooltip title={item.agentName} placement="bottom">
                    <span className="agent-name">{item.agentName || '-'}</span>
                  </Tooltip>
                </div>
              </div>
              <div className="meta-right">
                <div className="opinion-label">审批意见</div>
                <div
                  style={{
                    color: getOpinionColor(item.aiResult)
                  }}
                  className="opinion-content"
                >
                  {item.aiResult || ''}
                </div>
              </div>
            </div>

            <div className="approval-block-content">
              <Markdown content={item.content || ''} />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default AuditFlow